import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
interface Notification {
  flagCode: string;
  countryName: string;
  name: string;
  time: string;
}
const notifications: Notification[] = [{
  flagCode: 'us',
  countryName: 'United States',
  name: 'Emily',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  name: 'Sophie',
  time: '8 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  name: 'Olivia',
  time: '12 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  name: 'Chloe',
  time: '6 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  name: 'Emma',
  time: '9 minutes ago'
}, {
  flagCode: 'nz',
  countryName: 'New Zealand',
  name: 'Mia',
  time: '4 minutes ago'
}];

// Timing (ms)
const FIRST_DELAY: [number, number] = [7000, 10000];
const VISIBLE_FOR: [number, number] = [4000, 5000];
const GAP_BETWEEN: [number, number] = [15000, 20000];
const TICK_MS = 250;
function randomBetween([min, max]: [number, number]) {
  return Math.round(min + Math.random() * (max - min));
}
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  // Loop state lives in a ref so the recurring interval never goes stale.
  const loop = useRef({
    visible: false,
    nextIndex: 0,
    nextChangeAt: 0
  });
  useEffect(() => {
    loop.current = {
      visible: false,
      nextIndex: 0,
      nextChangeAt: Date.now() + randomBetween(FIRST_DELAY)
    };

    // Recurring interval: runs for the whole session and never stops,
    // cycling show → hide → wait → next, restarting after the last entry.
    const id = window.setInterval(() => {
      const state = loop.current;
      const now = Date.now();
      if (now < state.nextChangeAt) return;
      if (state.visible) {
        state.visible = false;
        state.nextIndex = (state.nextIndex + 1) % notifications.length;
        state.nextChangeAt = now + randomBetween(GAP_BETWEEN);
        setIsVisible(false);
      } else {
        state.visible = true;
        state.nextChangeAt = now + randomBetween(VISIBLE_FOR);
        setCurrentIndex(state.nextIndex);
        setIsVisible(true);
      }
    }, TICK_MS);
    return () => window.clearInterval(id);
  }, []);
  const handleClose = () => {
    // Hide only the current one; the loop keeps running.
    loop.current.nextChangeAt = Date.now();
  };
  const current = notifications[currentIndex];
  return <div className="fixed bottom-20 left-3 sm:bottom-6 sm:left-6 z-[60] pointer-events-none" aria-live="polite" data-id="element-237" data-mp="36rjkgai7olyl">
      <motion.div initial={false} animate={isVisible ? {
      opacity: 1,
      y: 0,
      scale: 1
    } : {
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} aria-hidden={!isVisible} className={`relative flex items-center gap-2.5 sm:gap-3 w-[250px] sm:w-[300px] bg-white border border-rose-100 rounded-xl py-2.5 pl-2.5 pr-7 sm:py-3 sm:pl-3 shadow-lg shadow-rose-900/15 ${isVisible ? 'pointer-events-auto' : 'pointer-events-none'}`} data-id="element-238" data-mp="2s3ge3009b899">
        <img src={`https://flagcdn.com/w80/${current.flagCode}.png`} alt={`Flag of ${current.countryName}`} className="w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover border border-amber-200 shrink-0" data-id="element-239" data-mp="2dfewizbwiffo" />

        <div className="min-w-0 leading-tight" data-id="element-240" data-mp="2ncb7dbp9vdne">
          <p className="text-[12px] sm:text-[13px] text-stone-800 truncate" data-id="element-241" data-mp="2iej45lj6g53w">
            <span className="font-bold" data-id="element-242" data-mp="2ie9fc19vc3zs">{current.name}</span>
            <span className="text-stone-600" data-id="element-243" data-mp="2w4uxfnri09wm"> — {current.countryName}</span>
          </p>
          <p className="text-[11px] sm:text-xs text-rose-800 font-medium mt-0.5 truncate" data-id="element-244" data-mp="2s42nesasy0za">
            Purchased Makeup Instructor Ready
          </p>
          <p className="text-[10px] sm:text-[11px] text-stone-500 mt-0.5" data-id="element-245" data-mp="361zn3xkjyni6">
            {current.time}
          </p>
        </div>

        <button type="button" onClick={handleClose} tabIndex={isVisible ? 0 : -1} className="absolute top-1.5 right-1.5 p-1 rounded text-stone-400 hover:text-stone-700 transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-700" aria-label="Close this notification" data-id="element-246" data-mp="3l7dggq83kah5">
          <X size={12} aria-hidden="true" data-id="element-247" data-mp="2uyyg00yg610" />
        </button>
      </motion.div>
    </div>;
}